import { FC } from 'react';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';

export const Div = styled.div<{ navBarHeight: number }>`
  align-items: center;
  border-top: ${spacing.single} solid ${colors.grey15};
  display: flex;
  flex: 0 0 ${({ navBarHeight }) => `${navBarHeight}px`};
  justify-content: space-between;
  min-height: ${({ navBarHeight }) => `${navBarHeight}px`};
  padding: ${spacing.half};
`;

export const DrawerFooter: FC<React.PropsWithChildren<unknown>> = (props) => {
  const navBarHeight = useNavBarHeight();
  return <Div navBarHeight={navBarHeight} {...props} />;
};
